<template>
  <v-select
    :items="assignmentList"
    item-value="id"
    item-text="projectName"
    v-model="assignmentIdValue"
    label="Assignment"
    :clearable="true"
    :disabled="true"
  ></v-select>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'

export default {
  props: [
    'assignmentId',
    'disabled'
  ],
  computed: {
    ...mapFields('assignments', [
      'assignmentList'
    ]),
    assignmentIdValue: {
      get () {
        return this.assignmentId
      },
      set (newValue) {
        this.$emit('assignmentIdChange', newValue)
      }
    }
  },
  methods: {
    ...mapActions('assignments', [
      'getUserAssignments'
    ])
  },
  created () {
    this.getUserAssignments()
  }
}
</script>
